import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueRouter from 'vue-router'
import router from './router'
import './router/permissions.js';

import store from './store/index.js'

//注册弹框插件
import layer from 'vue-pubilc-layer'
Vue.use(layer, {
  baseZ:100,
  hasMin: true,
  hasMax: false,
  move: true
});

import "@/icons"; // 注册svg矢量图标

import "@/styles/index.scss"; // 系统全局样式
Vue.use(ElementUI);
Vue.use(VueRouter)
Vue.use(store)


import * as turf from '@turf/turf'


window.turf=turf;
Vue.prototype.turf = turf;

// 配置bus
Vue.prototype.$bus = new Vue();


import { registerGlobComp } from "@/utils/registerGlobComp.js";
import { registerGlobProto } from "@/utils/registerGlobProto.js";
//import { registerGlobUse } from "@/utils/registerGlobUse.js";
import { registerGlobFilter } from "@/utils/registerGlobFilter.js";

registerGlobComp(Vue); //注册全局组件
registerGlobProto(Vue); // 注册全局方法
//registerGlobUse(Vue); //注册全局插件
registerGlobFilter(Vue); //注册全局指令

// 大屏相关
import ViewUI from 'view-design';  // 引入 iview
import 'view-design/dist/styles/iview.css';
import dataV from '@jiaminghi/data-view';
import Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';
import Highmaps from 'highcharts/modules/map';
HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
Highmaps(Highcharts);
import * as echarts from 'echarts';
import 'echarts-gl'
Vue.prototype.$echarts = echarts 
Vue.use(dataV);
Vue.use(ViewUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
